const SOUND_KEY = 'happytimes.shareSound';
export function shareSoundEnabled() {
  try { return localStorage.getItem(SOUND_KEY) !== 'off'; } catch { return true; }
}
export function setShareSoundEnabled(enabled) {
  try { localStorage.setItem(SOUND_KEY, enabled ? 'on' : 'off'); } catch {}
}
export function playShareSound() {
  if (!shareSoundEnabled()) return;
  const Audio = window.AudioContext || window.webkitAudioContext;
  if (!Audio) return;
  let context;
  try {
    context = new Audio();
    const chime = () => {
      const now = context.currentTime;
      [660, 880].forEach((frequency, index) => {
        const tone = context.createOscillator();
        const gain = context.createGain();
        const start = now + index * 0.06;
        tone.type = 'sine';
        tone.frequency.value = frequency;
        gain.gain.setValueAtTime(0, start);
        gain.gain.linearRampToValueAtTime(0.035, start + 0.012);
        gain.gain.exponentialRampToValueAtTime(0.001, start + 0.15);
        tone.connect(gain); gain.connect(context.destination);
        tone.start(start); tone.stop(start + 0.17);
        if (index === 1) tone.onended = () => { context.close().catch(() => {}); };
      });
    };
    if (context.state === 'suspended') context.resume().then(chime).catch(() => context.close().catch(() => {}));
    else chime();
  } catch { if (context) context.close().catch(() => {}); }
}
